export default __webpack_public_path__ + "static/media/PipelineJunction.256.8c26ce0c.png";